import type { Ref, TextareaHTMLAttributes } from 'react';
import { cx } from '../cx';
import { INPUT_BASE } from '../Input/Input';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  readonly invalid?: boolean | undefined;
  /**
   * The underlying element, for a caller that has to MEASURE it - `TextInput` grows a
   * multiline field to its content and there is no way to ask for a box's scroll height
   * without holding the box. Declared like `Input`'s, and it rides through `...rest`.
   */
  readonly ref?: Ref<HTMLTextAreaElement> | undefined;
}

export function Textarea({ invalid = false, className, rows = 3, ...rest }: TextareaProps) {
  return (
    <textarea
      rows={rows}
      aria-invalid={invalid || undefined}
      className={cx(
        INPUT_BASE,
        'resize-y leading-normal',
        invalid ? 'border-danger' : 'border-line hover:border-line-strong',
        className,
      )}
      {...rest}
    />
  );
}
